export default __webpack_public_path__ + "static/media/logo.74b560c2.png";